import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import CookbookReplaceIngredientMutation from './CookbookReplaceIngredientMutation';
import CookbookMealQuery from '../Meal/CookbookMealQuery';
import optimisticResponse from './ReplaceIngredientOptimisticResponse';

const ReplaceIngredientConnectorApollo = ({ children, mealId }) => {
  const [replaceIngredient, { data, loading, error }] = useMutation(
    CookbookReplaceIngredientMutation,
    {
      refetchQueries: [
        {
          query: CookbookMealQuery,
          variables: {
            mealId,
          },
        },
      ],
    }
  );

  const createReplaceIngredient = async (
    dishId,
    originalIngredientId,
    replacementIngredientId,
    key,
    name,
    measurements
  ) => {
    const response = await replaceIngredient({
      variables: {
        dishId,
        originalIngredientId,
        replacementIngredientId,
      },
      optimisticResponse,
      update: (cache) => {
        const cachedProductToFindById = {
          __typename: 'CookbookIngredient',
          key,
        };

        cache.modify({
          id: cache.identify(cachedProductToFindById),
          fields: {
            name() {
              return name;
            },
            measurements() {
              return measurements;
            },
          },
          broadcast: true,
        });
      },
    });

    if (response.data.cookbook.replaceIngredient.__typename !== 'BasicMutationSuccess') {
      throw new Error(
        `Replace product failed: ${response.data.cookbook.replaceIngredient.__typename}`
      );
    }

    return response;
  };

  return children({
    replaceIngredient: {
      replace: createReplaceIngredient,
      response: data,
      loading,
      error,
    },
  });
};

ReplaceIngredientConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default ReplaceIngredientConnectorApollo;
